module.exports = __webpack_public_path__ + "img/gas6.a411b962.png";